import { SCENARIO_REGISTRY } from "../data/scenario-registry";
import type { ProethicsScenarioId } from "../types";

export const resolveHint = (
	currentHint: string | null,
	scenarioId: ProethicsScenarioId,
): string => currentHint ?? SCENARIO_REGISTRY[scenarioId].openingHint;
